import { StylesConfig } from "react-select";
import { LangE } from "../../../models/enums";

export const selectStyles = (lang: LangE): StylesConfig<any, false> => ({
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected || state.isFocused ? '#F4F6F8' : '#ffffff',
        color: '#1E1E20',
        fontSize: '0.87rem',
        lineHeight: '1.31rem',
    }),
    control: (provided, state) => ({
        ...provided,
        width: 170,
        height: 30,
        background: state.isDisabled ? '#ececec' : '#ffffff',
        borderRadius: 10,
        border: `1px solid ${state.menuIsOpen || state.isFocused ? '#34A7F0' : '#9a9a9a'}`,
        boxShadow: 'none',
        cursor: 'pointer',
        position: 'relative',
        "&:hover": {
            outline: 'none',
            boxShadow: 'none',
        },
        "&:active": {
            outline: 'none',
            boxShadow: 'none',
        },
        "&:focus": {
            outline: 'none',
            boxShadow: 'none',
        }
    }),
    indicatorSeparator: () => ({}),
    placeholder: (provided) => ({
        ...provided,
        fontFamily: lang === LangE.EN ? 'Roboto' : 'Rubik',
        fontSize: '.87rem',
        lineHeight: '1.31rem',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: 0,
        paddingInlineStart: 20,
        fontFamily: lang === LangE.EN ? 'Roboto' : 'Rubik',
        fontSize: '.87rem',
        lineHeight: '1.31rem',
    }),
    singleValue: (provided, state) => ({
        ...provided,
        display: state.selectProps.menuIsOpen ? 'none' : 'block',
        paddingBottom: 5,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: 8,
        paddingInlineEnd: 13,
    }),
    menu: (provided) => ({
        // ...provided,
        // boxShadow: '0px 4px 8px rgba(116, 116, 116, 0.25)',
        borderRadius: 5,
        backgroundColor: '#fff',
        marginBottom: -8,
        marginTop: 8,
    }),
    menuList: (provided) => ({
        ...provided,
        // boxShadow: '0px 4px 8px rgba(193, 193, 193, 0.25)',
        // border: '1px solid #F1F1F1',
        outline: 'none',
        border: 'none',
        boxShadow: 'none',
        borderRadius: 5,
        backgroundColor: '#fff',
        transform: 'translateY(10px)',
        direction: lang === LangE.EN ? 'ltr' : 'rtl',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 999,
        "&::before": {
            content: '""',
            display: 'block',
            width: '100%',
            height: 'calc(100% + 56px)',
            position: 'absolute',
            borderRadius: 10,
            border: '8px solid white',
            boxShadow: '0px 2px 8px rgba(193, 193, 193, 0.7)',
            transform: 'translate(-8px, -56px)',
        },
    }),
});